import { IPlanePoint } from './interfaces';

export class PlanePoint implements IPlanePoint {
    constructor(public x: number, public y: number) {
    }
}
